import approvalprocessList from "./list.vue"

let a = Object.assign({ approvalprocessList })

export default a